<template>
  <b-modal
    static
    ref="editBrandModal"
    size="md"
    :title-html="brandID ? '<i class=\'mr-1\'></i> Edit Brand' : '<i class=\'mr-1\'></i> Create Brand'"
    title-class="font-18"
    no-close-on-esc
    no-close-on-backdrop
    centered
    body-class="bg-light"
    hide-footer
    hide-header-close
    @change="renderAvatar"
    >
    <form
      @submit.prevent="onSave">
      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
        {{errorMessage}}
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="avatar-upload" v-if="brandID">
            <div class="avatar-edit">
              <input 
                type='file' 
                id="imageUpload" 
                @change="onAvatarChange"
                accept=".png, .jpg, .jpeg" />
              <label for="imageUpload"><i class="uil uil-pen"></i>  </label>
            </div>
            <div class="avatar-preview">
              <img
                ref="imagePreview"
                :src="model.logo"
                alt
                class="avatar-md"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <TextField 
            :placeholder="$t('brand.form.name.placeholder')"
            :label="$t('brand.form.name.label')"
            v-model="model.name"
            :error="$v.model.name.$error"
            :errorMessage="$v.model.name.errorMessage"
          />
          <TextField 
            :placeholder="$t('brand.form.remarks.placeholder')"
            :label="$t('brand.form.remarks.label')"
            v-model="model.remarks"
          />
        </div>
      </div>

    </form>
    <div>
      <div class="float-right">
        <button class="btn btn-dark btn-sm mr-2" @click="hide">Cancel</button>
        <Button class="btn btn-primary btn-sm" @click="onSave" :loading="loading">
          <i class='uil-user-plus mr-1'></i> Update
        </Button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import TextField from '@components/form/textfield.vue'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import timezone from '@src/data/timezone.json'

export default {
  mixins: [FormMixin],
  components:{TextField},
  props: ['brandID'],
  data(){
    return {
      model:{
        name: '',
        remarks: '',
        fixed:false,
        website: '',
        contact_no: '',
        email: '',
        avatar_path: '',
        city: '',
        country: '',
        rate:0,
        timezone:''
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      timezone_option:timezone,
      industry_options:[],
      function_options:[],
    }
  },
  validations: {
    model:{
      name: { required },
      email: { required },
      timezone: { required },
      contact_no: { required },
      city: { required },
      country: { required },
    }
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    ...mapActions('brand', ['create', 'update', 'find', 'uploadLogo']),
    renderAvatar(val){
      if(val){
        if(this.brandID){
          this.find({
            id:this.brandID
          }).then(data => {
            this.model = data.data
            this.model.logo = this.model.logo != '' ? this.model.logo : require('@assets/images/users/avatar-7.jpg')
          })
        }
      }
    },
    onAvatarChange(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("avatar", input.files[0]);
        formData.append("id", this.brandID);

        this.uploadLogo(formData).then(res => {

          if(res.data.success == true){
            var reader = new FileReader();

            reader.onload = (a) => {
              this.$refs['imagePreview'].src = a.target.result
              this.toggleLoading()
            }

            reader.readAsDataURL(input.files[0]);
          }else{
            this.toggleLoading()
          }
          
        })
      }

    },
    onSave() {
      this.model.id = this.brandID
      this[!this.brandID ? 'create' : 'update'](this.model)
      .then(()=> {
        this.toggleLoading()
        this.$emit('fetchData')
        this.hide()
      })
      .catch((err) => {
        this.toggleLoading()

        Object.keys(err.response.data).forEach(key => {
          if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
        })

        this.setError(err.response.data.msg)

      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onCancel() {
      this.$refs.editBrandModal.show()
    },
    hide(){
      this.$refs.editBrandModal.hide()
    },
    show(){
      this.$refs.editBrandModal.show()
    },
  }
}
</script>